
import { Transition } from "../../../core/flows/Transition";
import { BookItAgainContext } from "../../BookItAgain/Context/BookItAgainContext";
import { ChangeDateContext } from "../../ChangeDate/Context/ChangeDateContext";
import { ManageSeatingContext } from "../../ManageSeating/Context/ManageSeatingContext";
import { TicketDetailContext } from "../../TicketDetail/Context/TicketDetailContext";
import { BookingDetailContext } from "../Context/BookingDetailContext";
import { BookReturnJourneyContext } from "../../BookReturnJourney/Context/BookReturnJourneyContext";

export class BookingDetailTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<BookingDetailContext>("bookingDetailContext", this.entryStep)!

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        const ticketDetailContext = new TicketDetailContext()
        this.setCtx<TicketDetailContext>("ticketDetailContext", ticketDetailContext, this.entryStep)

        const bookItAgainContext = new BookItAgainContext()
        this.setCtx<BookItAgainContext>("bookItAgainContext", bookItAgainContext, this.entryStep)

        const changeDateContext = new ChangeDateContext()
        this.setCtx<ChangeDateContext>("changeDateContext", changeDateContext, this.entryStep)

        const manageSeatingContext = new ManageSeatingContext()
        this.setCtx<ManageSeatingContext>("manageSeatingContext", manageSeatingContext, this.entryStep)

        const bookReturnJourneyContext = new BookReturnJourneyContext()
        this.setCtx<BookReturnJourneyContext>("bookReturnJourneyContext", bookReturnJourneyContext, this.entryStep)

        context.routeTo = ["BookingDetail_Step", "BookItAgainFlow", "ChangeDateFlow", "ManageSeatingFlow", "BookReturnJourneyFlow", "JourneyPlannerFlow"];

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}